// 案件状态
export const reportStateList = [{
  value: 'untreated',
  label: '报案受理'
}, {
  value: 'holdedOn',
  label: '资料收集'
}, {
  value: 'returned',
  label: '补充资料'
}, {
  value: 'surveied',
  label: '已查勘'
}, {
  value: 'claiming',
  label: '理赔中'
}, {
  value: 'claimReturned',
  label: '理赔补充'
}, {
  value: 'checked',
  label: '已定损'
}, {
  value: 'finished',
  label: '已结案'
}]

// 案件子状态/结案状态
export const finishedStateList = [{
  value: 'refound',
  label: '银行退票'
}, {
  value: 'remittFailed',
  label: '打款失败'
}, {
  value: 'reRemitt',
  label: '重新打款'
}, {
  value: 'remitted',
  label: '结案打款'
}, {
  value: 'withdraw',
  label: '用户撤案'
}, {
  value: 'reject',
  label: '拒赔'
}]

// 定损状态
export const lossStateList = [{
  value: 'tocheck',
  label: '待定损'
}, {
  value: 'checking',
  label: '定损中'
}, {
  value: 'checked',
  label: '定损通过'
}, {
  value: 'nonecheck',
  label: '无需定损'
}, {
  value: 'forcechecked',
  label: '强制完成'
}]
// 定损子状态
export const lossSubStateList = [{
  value: 'dealing',
  label: '定损处理'
}, {
  value: 'return',
  label: '定损退回'
}, {
  value: 'submitted',
  label: '已补充'
}]

// 事故类型（多方/单方）
export const accidentFirstTypeList = [{
  value: '',
  label: '单方/多方'
}, {
  value: 'SINGLE_CAR',
  label: '单方'
}, {
  value: 'MULTI_CAR',
  label: '多方'
}]

// 事故类型（人/车/物）
export const accidentSecondTypeList = [{
  value: 'injury',
  label: '仅人伤'
}, {
  value: 'damage_carLoss',
  label: '仅车物'
}, {
  value: 'injury_damage_carLoss',
  label: '人+车（物）'
}]

// 是否协作
export const coopTaskTypeList = [{
  value: 'NONE',
  label: '非协作'
}, {
  value: 'TODEAL',
  label: '需协作'
}, {
  value: 'COMPLETED',
  label: '协作完成'
}]

// 投诉等级/是否投诉
export const complaintLevelList = [{
  value: 'COMPL_BASIC',
  label: '基础投诉'
}, {
  value: 'COMPL_95500',
  label: '955投诉'
}, {
  value: 'COMPL_COMPANY',
  label: '保险公司投诉'
}, {
  value: 'COMPL_BANK_COMM',
  label: '保监投诉'
}];

// 饿了么状态
export const elemeAuditStatusList = [{
  value: 'ONLINE_INFO_TO_BE_SUBMITTED_TO_INSURE_COMPANY',
  label: '资料待提交'
}, {
  value: 'ONLINE_INFO_CHECKING',
  label: '电子资料审核中'
}, {
  value: 'ONLINE_INFO_TO_BE_ADDED',
  label: '待补充电子资料'
}, {
  value: 'PAPER_INFO_TO_BE_ADDED',
  label: '待补充纸质资料'
}, {
  value: 'PAPER_INFO_CHECKING',
  label: '纸质资料审核中'
}, {
  value: 'REJECT',
  label: '拒赔'
}, {
  value: 'CASE_CLOSED_WITH_NO_PAY',
  label: '0结'
}, {
  value: 'ACCOUNT_COMPLETE',
  label: '赔付成功'
}, {
  value: 'CANCEL',
  label: '撤案'
}, {
  value: 'CANCEL_BY_INSURE_COMPANY',
  label: '注销'
}]
//前海饿了么状态
export const QIANHAIelemeAuditStatusList = [{
  value: 1,
  label: '资料待提交'
}, {
  value: 2,
  label: '电子资料审核中'
}, {
  value: 3,
  label: '待补充电子资料'
}, {
  value: 4,
  label: '待补充纸质资料'
}, {
  value: 5,
  label: '纸质资料审核中'
}, {
  value: 6,
  label: '拒赔'
}, {
  value: 7,
  label: '0结'
}, {
  value: 8,
  label: '赔付成功'
}, {
  value: 9,
  label: '撤案'
}, {
  value: 10,
  label: '注销'
}]


// 人伤情况
export const casualtyList = [{
  value: '1',
  label: '受伤'
}, {
  value: '4',
  label: '骨折'
}, {
  value: '3',
  label: '身故'
}]

/**
 * 保司案件状态
 * value: 租户code
 * list: 租户对应的保司状态
 */
export const caseStatusList = [{
  value: 13,
  list: [{
    value: '0',
    label: '报未立'
  }, {
    value: '1',
    label: '立未理'
  }, {
    value: '2',
    label: '理未核'
  }, {
    value: '3',
    label: '核未结'
  }, {
    value: '4',
    label: '已结案'
  }, {
    value: '5',
    label: '零结案'
  }, {
    value: '6',
    label: '报案注销'
  }, {
    value: '7',
    label: '立案注销'
  }, {
    value: '8',
    label: '立案拒赔'
  }]
}, { 
  // 人保达达保司状态insureCompStatus
  value: 17,
  list: [{
    value: '00',
    label: '待核赔'
  }, {
    value: '02',
    label: '驳回待提交'
  }, {
    value: '04',
    label: '驳回待上传'
  }, {
    value: '05',
    label: '案件取消'
  }, {
    value: '06',
    label: '通过待同步'
  }, {
    value: '07',
    label: '通过但同步失败'
  }, {
    value: '08',
    label: '通过已同步'
  }, {
    value: '10',
    label: '报未立'
  }, {
    value: '11',
    label: '立未理'
  }, {
    value: '12',
    label: '理未核'
  }, {
    value: '13',
    label: '核未结'
  }, {
    value: '14',
    label: '已结案'
  }, {
    value: '15',
    label: '零结案'
  }, {
    value: '16',
    label: '报案注销'
  }, {
    value: '17',
    label: '立案注销'
  }, {
    value: '18',
    label: '立案拒赔'
  }]
}, {
  value: 18,
  list: [{
    value: '0',
    label: '未推送'
  }, {
    value: '1',
    label: '已推送'
  }, {
    value: '2',
    label: '已结案'
  }]
}, {
  // JD/北分达达保司状态 insureCompStatus
  value: 28,
  list: [{
    value: '10',
    label: '已报案'
  }, {
    value: '11',
    label: '保司已立案'
  }, {
    value: '12',
    label: '待补充材料'
  }, {
    value: '13',
    label: '待材料寄送'
  }, {
    value: '14',
    label: '保司理赔调查'
  }, {
    value: '15',
    label: '保司已理算'
  }, {
    value: '16',
    label: '保司核赔通过'
  }, {
    value: '160',
    label: '保司核赔驳回'
  }, {
    value: '17',
    label: '保司拒赔'
  }, {
    value: '18',
    label: '保司支付赔款'
  }, {
    value: '19',
    label: '保司已结案'
  }, {
    value: '20',
    label: '案件取消'
  }]
}]

// 我的任务工单列表搜索项，exclude是不包含项，include是包含项
export const reportSearchParams = [
  {
    value: 'flowId',
    label: '受理号',
    excludeCode: []
  },
  {
    value: 'claimId',
    label: 'JD理赔单号',
    includeCode: [28]
  },
  {
    value: 'reportId',
    label: '报案号',
    excludeCode: []
  },
  {
    value: 'partnerClaimNo',
    label: '饿了么理赔单',
    includeCode: [21]
  },
  {
    value: 'ownIdCardNo',
    label: '标的身份证',
    excludeCode: []
  },
  {
    value: 'policyNo',
    label: '保单号',
    excludeCode: [19]
  },
  {
    value: 'reporterName',
    label: '报案人姓名',
    excludeCode: [18, 19]
  },
  {
    value: 'reporterCellPhone',
    label: '报案人电话',
    excludeCode: [18, 19, 21]
  },
  {
    value: 'insuredName',
    label: '被保人姓名',
    excludeCode: [19, 20, 21]
  },
  {
    value: 'claimNo',
    label: '赔案号',
    excludeCode: [18, 19, 20, 21]
  },
  {
    value: 'ownCarLossName',
    label: '标的姓名',
    includeCode: [8, 13, 16, 18, 19, 20, 21]
  },
  {
    value: 'cicHelloOrderId',
    label: '投保订单号',
    includeCode: [14]
  },
  {
    value: 'ciccHelloOrderId',
    label: '投保订单号',
    includeCode: [16]
  },
  {
    value: 'orderId',
    label: '投保订单号',
    includeCode: [19]
  },
  {
    value: 'insuredIdCardNo',
    label: '被保人证件号',
    includeCode: [18]
  },
  {
    value: 'websiteCode',
    label: '网点代码',
    includeCode: [13]
  },
  {
    value: 'websiteName',
    label: '网点名称',
    includeCode: [13]
  }
];

// 撤案推荐的枚举
export const recommendWithdrawStatus = {
  toDeal: '待处理',
  waiting: '等待',
  valid: '有效',
  invalid: '无效',
};

// 医疗类型枚举
export const medicalTypes = [
  { label: '门诊', value: 'outpatient' },
  { label: '住院', value: 'hospoital' }
];

// 损失类型枚举
export const lossTypes = [{
  value: 'person',
  label: '人'
}, {
  value: 'car',
  label: '车'
}, {
  value: 'damage',
  label: '物'
}]

export const JD_CERT_TYPE_OPTIONS = [
  { value: 1, label: '身份证' },
  { value: 2, label: '护照' },
  { value: 3, label: '军官证' },
  { value: 4, label: '台胞证（台湾居民来往大陆通行证）' },
  { value: 5, label: '其它' },
  { value: 6, label: '统一社会信用代码' },
  { value: 8, label: '出生证明' },
  { value: 9, label: '其它' },
  { value: 10, label: '工商营业执照' },
  { value: 11, label: '税务登录证' },
  { value: 12, label: '回乡证(港澳居民来往内地通行证)' },
  { value: 13, label: '警官证' },
  { value: 14, label: '台湾居民居住证' },
  { value: 15, label: '机动车驾驶证' },
  { value: 16, label: '户口本' },
  { value: 17, label: '港澳台居民居住证' },
  { value: 18, label: '外国人永久居留身份证' },
  { value: 19, label: '外国护照' },
  { value: 20, label: '港澳通行证' },
  { value: 21, label: '社保卡' },
];

export const JD_PAYEE_TYPE_OPTIONS = [
  { value: 1, label: '被保险人' },
  { value: 2, label: '被委托人' },
  { value: 3, label: '受益人' },
  { value: 4, label: '服务供应商' },
  { value: 5, label: '监护人' },
  // { value: '6', label: '三者' },
  // { value: '7', label: '维修厂' },
  // { value: '8', label: '医院' },
  // { value: '9', label: '法院' },
  // { value: '10', label: '保险公司' }
  { value: 99, label: '其他' },
];

// 转派权限
export const DISPATCH_PERMISSION = {
  REPORT_DISPATCH_SELF: 'reportDispatchSelf',
  REPORT_DISPATCH_ORG: 'reportDispatchOrg',
  REPORT_DISPATCH_COMPANY: 'reportDispatchCompany'
}

// 太保饿了么证件类型
export const CARD_TYPES_OF_CPIC = [
  { label: '居民身份证', value: '111' },
  { label: '护照', value: '114' },
  { label: '军人证', value: '113' },
  { label: '其他', value: '999' }
];

export const CARD_TYPES_CODE_OF_CPIC = {
  ID_CARD: '111'
}
